import { useEffect, useState } from "react";
import api from "../lib/api";

const CACHE_KEY = "bvg_version_cache";
const CACHE_TTL_MS = 60 * 60 * 1000; // 1 jam
const FALLBACK = process.env.REACT_APP_VERSION || "1.0.0";

export default function VersionLabel() {
    const [info, setInfo] = useState(null);

    useEffect(() => {
        let mounted = true;
        try {
            const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || "null");
            if (cached && Date.now() - cached.ts < CACHE_TTL_MS) {
                setInfo(cached.data);
                return;
            }
        } catch { /* ignore */ }
        api.get("/version")
            .then((r) => {
                if (!mounted) return;
                setInfo(r.data);
                try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: r.data })); } catch {}
            })
            .catch(() => {
                if (mounted) setInfo({ version: FALLBACK, release_date: "", latest_change: "" });
            });
        return () => { mounted = false; };
    }, []);

    const v = info?.version || FALLBACK;
    const tanggal = info?.release_date || "";
    const latest = info?.latest_change || "";
    const tooltip = `Build: v${v}${tanggal ? " · " + tanggal : ""}${latest ? " · " + latest : ""}`;

    return (
        <div
            className="px-3 py-2 border-t border-slate-700 text-slate-500 text-[10px] leading-tight select-none"
            title={tooltip}
            data-testid="sidebar-version-label"
        >
            <div className="text-slate-400">
                Buku Vendor Garment <span className="font-mono text-slate-300" data-testid="app-version">v{v}</span>
            </div>
            <div className="text-slate-500">© CV. Meranggi Jaya {new Date().getFullYear()}</div>
        </div>
    );
}
